module.exports = __webpack_public_path__ + "img/logo-safe-medical-inline.7426a420.png";